export default "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?5d42b4e60858731e7b6504400f7e3d8e";